import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Button } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap'
import { Link } from 'react-router-dom';
import logo from './../images/ADTN-Logo-Landing.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDiscord } from '@fortawesome/free-brands-svg-icons';
import moment from 'moment';
import {authSelector, chapterMemberSelector, chapterSelector} from "../redux/selectors";
import {openChapters, toArray} from "../common/util";
import {fetchChapterMembers} from "../redux/actions";
import FlipMove from 'react-flip-move';

class Landing extends Component {
    componentDidMount() {
        document.title = "Addiction";
        openChapters(this.props.chapters)
            .filter(chapter => chapter.game.title !== "Addiction")
            .map((chapter) => {
                this.props.getChapterMembers(chapter.id);
                return null;
            });
    }
    render() {
        return (
            <div className="landing">
                <FlipMove
                    staggerDelayBy={100}
                    appearAnimation="fade"
                    enterAnimation="fade"
                    leaveAnimation="fade"
                >
                    <div className="panel-adt">
                        <Row style={{padding: "5%"}}>
                            <Col md={9}>
                                <div className="text-left flex-header">
                                    <h2 className="text-primary" style={{fontSize:"40px"}}>Compete with some of the world's top MMO players</h2>
                                    <p>Remember that game you played way back when, that whenever the subject comes up you can’t shut up about it? Those few guys you played with.. and kicked everyone’s ass with? Yeah.. we’re those guys.</p>

                                    <p><span className="adt-username text-primary">Addiction</span> is a multi-gaming organization renowned for its world leading achievements across
                                        multiple MMOs.</p>
                                    <div>
                                    {this.props.auth.loggedIn ?
                                        (
                                        <LinkContainer to="/apply">
                                            <Button>Apply Now</Button>
                                        </LinkContainer>
                                        ) : (
                                            <LinkContainer to="/register">
                                            <Button>Get Started</Button>
                                        </LinkContainer>
                                        )
                                    }
                                    </div>
                                </div>
                            </Col>
                            <Col md={3} className="text-center">
                                <img width="100%" height="100%" alt="Addiction" src={logo}/>
                            </Col>
                        </Row>
                    </div>
                    <div className="panel-adt">
                        <Row className="text-center">
                            <h2 className="quote">Hardest of the Hardcore <footer>Scott Hartsman, CEO Trion Worlds</footer>
                            </h2>
                        </Row>
                        <Row>
                            <Col md={6} style={{padding: "10px 5%"}}>
                                <p><span className="adt-username text-primary">Addiction</span> is a MMO guild and gaming community that has successfully transitioned
                                    through <strong className="text-primary">19</strong> MMOs and counting. Our original
                                    leadership has retained and grown our core member base over the last <strong className="text-primary">{moment("2006-03-13", "YYYY-MM-DD").fromNow().split(' ')[0]}</strong> years and we are
                                    always looking for more skilled and loyal members.</p>
                            </Col>
                            <Col md={6} style={{padding: "10px 5%"}}>
                                <p><span className="adt-username text-primary">Addiction</span> has a deep list of accolades and accomplishments. Our efforts in RIFT
                                    landed us as the #1 progression guild worldwide with our first raid boss kill in under
                                    a week after launch.  <span className="adt-username text-primary">Addiction</span> maintained its position as the #1
                                    raiding guild in RIFT for three years before leaving the game.</p>
                            </Col>
                        </Row>
                    </div>
                    <Row>
                        <Col md={3}>
                            <div className="panel-adt text-center">
                                <h2 className="text-primary text-huge">14</h2>
                                <h3>World First</h3>
                                <h4><span className="text-primary">58</span> Server First</h4>
                                <p>Raid Boss Kills</p>
                            </div>
                        </Col>
                        <Col md={3}>
                            <div className="panel-adt text-center">
                                <h2 className="text-primary text-huge">1</h2>
                                <h3>Esports Pro League</h3>
                                <h4>Rainbow 6: Siege</h4>
                                <p>Competitive Team</p>
                            </div>
                        </Col>
                        <Col md={3}>
                            <div className="panel-adt text-center">
                                <h2 className="text-primary text-huge">{moment("2006-03-13", "YYYY-MM-DD").fromNow().split(' ')[0]}</h2>
                                <h3>Years</h3>
                                <h4><span
                                    className="text-primary">{moment().startOf('year').add(3, 'months').add(13, 'days').fromNow().split(' ')[0]}</span> months
                                </h4>
                                <p>since forming</p>
                            </div>
                        </Col>
                        <Col md={3}>
                            <div className="panel-adt text-center">
                                <h2 className="text-primary text-huge">19</h2>
                                <h3>MMOs played</h3>
                                <h4><span className="text-primary">{toArray(this.props.chapterMembers.data)
                                    .filter(member => member.leaveDate === null)
                                    .filter(member => this.props.chapters[member.chapter].game.title !== "Addiction")
                                    .filter(member => this.props.chapters[member.chapter].closeDate === null)
                                    .length}</span> Active Members</h4>
                                <p>and counting</p>
                            </div>
                        </Col>
                    </Row>
                    <div className="panel-adt">
                        <div className="text-center">
                            <h2>How to Join</h2>
                            <p className="text-center" style={{maxWidth: "60%", display: "inline-block"}}><span className="adt-username text-primary">Addiction</span> uses a
                                multi-step process applicants must follow in order to become members of one of our gaming
                                Chapters. This ensures you will be playing with like-minded peers when you get in-game.</p>
                        </div>
                        <div style={{padding: "5%"}}>
                            <Row>
                                <Col md={6}>
                                    <div className="flex-how-to">
                                        <h2 className="text-primary text-huge num-spacing">1</h2>
                                        <div style={{display:"inline-block",margin:"10px"}}>
                                            <h3>Register</h3>
                                            <p>Registration takes seconds and is needed to interact with this website.</p>
                                        </div>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="flex-how-to">
                                        <h2 className="text-primary text-huge num-spacing">2</h2>
                                        <div style={{display:"inline-block",margin:"10px"}}>
                                            <h3>Apply</h3>
                                            <p>Begin your multi-step application.  Each step is reviewed by a Recruitment Officer to ensure <span className="adt-username text-primary">Addiction</span> is filled with like-minded players.</p>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                   <div className="flex-how-to">
                                        <h2 className="text-primary text-huge num-spacing">3</h2>
                                        <div style={{display:"inline-block",margin:"10px"}}>
                                            <h3>Interview on Discord</h3>
                                            <p>Join our <a target="_blank" rel="noopener noreferrer" href="https://discord.gg/addictguild"><FontAwesomeIcon className="text-primary" icon={faDiscord} fixedWidth /> Discord</a> server and speak to a Recruitment Officer.</p>
                                        </div>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="flex-how-to">
                                        <h2 className="text-primary text-huge num-spacing">4</h2>
                                        <div style={{display:"inline-block",margin:"10px"}}>
                                            <h3>Lifetime Membership</h3>
                                            <p>All members have a lifetime membership and are welcome to return and join us for any new game <span className="adt-username text-primary">Addiction</span> is planning on playing.</p>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                        <div className="text-center">
                            {this.props.auth.loggedIn ?
                                (
                                <LinkContainer to="/apply">
                                    <Button>Apply Now</Button>
                                </LinkContainer>
                                ) : (
                                    <LinkContainer to="/register">
                                    <Button>Get Started</Button>
                                </LinkContainer>
                                )
                            }
                            <div>
                                <Link to="/about/rules">Learn more about Addiction</Link>
                            </div>
                        </div>
                    </div>
                </FlipMove>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    auth: authSelector(state),
    chapters: chapterSelector(state),
    chapterMembers: chapterMemberSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
    getChapterMembers: (chapter) => dispatch(fetchChapterMembers(chapter)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Landing);


// WEBPACK FOOTER //
// ./src/Landing/Landing.js